import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    CircularProgress,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    FormControlLabel,
    Checkbox,
    FormLabel,
    Tooltip,
    IconButton
} from '@material-ui/core/';

import SortableTree from "react-sortable-tree";
import FileExplorerTheme from 'react-sortable-tree-theme-full-node-drag';
import ChipInput from 'material-ui-chip-input';

import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';
import AddIcon from '@material-ui/icons/Add';

import OverrideDialog from "./OverrideDialog";
import EditTupleDescriptionDialog from './EditTupleDescriptionDialog';
import SaveToPlanDialog from "./SaveToPlanDialog";

import { SelectDataType } from '@apricityhealth/web-common-lib/components/SelectDataType';
import { SelectDataTypeCategory } from '@apricityhealth/web-common-lib/components/SelectDataTypeCategory';
import { SelectTupleIndex } from '@apricityhealth/web-common-lib/components/SelectTupleIndex';
import { Logger } from "@apricityhealth/web-common-lib/utils/Logger";
import UploadFile from "@apricityhealth/web-common-lib/components/UploadFile";
import getErrorMessage from "@apricityhealth/web-common-lib/utils/getErrorMessage";
import createIdFromText from "../utils/CreateIdFromText";
import ChangedByButton from "../components/ChangedByButton";

const log = new Logger();
class EditDataTypeDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataType: props.dataType ? JSON.parse(JSON.stringify(props.dataType))
                : { dataId: '', name: '', description: '', category: '', tupleDescriptions: [] },
            progress: null,
            dialog: null
        };
    }

    componentDidMount() {
        this.createTreeData();
    }

    componentDidUpdate(oldProps) {
        //note - props never seems to be changed in the current interface
        const oldData = JSON.stringify(oldProps.dataType)
        const currentData = JSON.stringify(this.props.dataType)
        if (oldData !== currentData) {
            this.setState({ dataType: JSON.parse(JSON.stringify(this.props.dataType)) }, this.createTreeData.bind(this));
        }
    }

    displayOverrideDialog(oldPlanId, callback) {
        this.setState({
            dialog: <OverrideDialog appContext={this.props.appContext}
                oldPlanId={oldPlanId} parent={this} onConfirm={callback} />
        });
    }

    onCancel() {
        const { onCancel } = this.props;
        if (onCancel)
            onCancel();
    }

    onSaveIntoPlan() {
        const dialog = <SaveToPlanDialog appContext={this.props.appContext} planId={this.state.dataType.planId} onCancel={this.onCloseDialog.bind(this)}
            onDone={({ plan, move }) => {
                console.log("plan:", plan, ", move: ", move);
                this.onSave(move, plan.planId)
            }} />;
        this.setState({ dialog });
    }

    onDone() {
        const { onDone, previewMode } = this.props;
        const { dataType } = this.state;
        if ( previewMode && this.props.dataType ) {
            for(let k in dataType) {
                this.props.dataType[k] = dataType[k];
            }
        }
        if ( onDone ) 
            onDone(dataType);
        log.debug("onDone:", dataType, this.props.dataType );
    }

    onSave(move = false, planId = null) {
        const { onDone, appContext, previewMode } = this.props;
        const { dataType } = this.state;

        // if we have no tuples, then create any default tuples for the given type..
        if ( dataType.tupleDescriptions.length === 0 ) {
            this.updateTupleDescriptions();
        }
        if ( previewMode ) {
            for(let k in dataType) {
                this.props.dataType[k] = dataType[k];
            }
            if ( onDone ) onDone(dataType);
            return dataType;
        }

        const originalPlanId = dataType.planId;
        if (!planId && dataType.planId && dataType.planId !== appContext.state.plan.planId) {
            return this.displayOverrideDialog(dataType.planId, this.onSave.bind(this, false));
        }

        const linkStore = appContext.stores.DataTypesStore;

        let tupleUpdates = [];
        for (let i = 0; i < dataType.tupleDescriptions.length; ++i) {
            let tupleDesc = dataType.tupleDescriptions[i];
            if (tupleDesc.oldIndex !== tupleDesc.index) {
                tupleUpdates.push({ oldIndex: tupleDesc.oldIndex, newIndex: tupleDesc.index });
            }
        }

        if (tupleUpdates.length > 0) {
            try {
                linkStore.updateTupleIndexes(dataType.dataId, tupleUpdates);
            }
            catch (err) {
                console.error("updateTupleIndexs error:", err);
                return this.setState({ error: getErrorMessage(err) });
            }
        }

        const store = appContext.stores.DataTypesStore;
        this.setState({ dialog: null, progress: <CircularProgress size={20} />, error: null });
        return store.saveDataType(dataType, planId).then(() => {
            if (move && planId !== originalPlanId) {
                return store.deleteDataType(dataType.dataId, originalPlanId);
            }
        }).then(() => {
            if (onDone)
                onDone(dataType);
            this.setState({ progress: null });
        }).catch((error) => {
            this.setState({ progress: null, error: getErrorMessage(error) });
        });
    }

    onDelete() {
        const { dataType } = this.state;

        this.setState({ dialog: <Dialog open={true}>
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>Please confirm you want to delete this data type?</DialogContent>
            <DialogActions>
                <Button style={styles.button} onClick={() => {
                    const { appContext: { stores: { DataTypesStore : store }}} = this.props;
                    store.deleteDataType(dataType.dataId, dataType.planId );
                    this.onCancel();
                }}>Confirm</Button>
                <Button style={styles.button} onClick={() => this.setState({ dialog: null })}>Cancel</Button>
            </DialogActions>
        </Dialog>})
    }

    onChange = type => e => {
        let { dataType } = this.state;
        dataType[type] = e.target.value;
        this.setState({ dataType });
    }

    onChange = type => e => {
        let { dataType } = this.state;
        dataType[type] = e.target.value;
        if (type === 'name') {
            dataType.dataId = createIdFromText(dataType.name)
        }
        this.setState({ dataType });
    }

    showConfirmUpdateDialog() {
        const dialog = <Dialog
            maxWidth={'md'}
            fullWidth={true}
            model="false"
            open={true}
        >
            <DialogContent>
                Are you sure you want to overwrite the current <b> tuple descriptions</b>?
            </DialogContent>
            <DialogActions>
                <Button variant="contained" self={this} style={styles.button} onClick={(e) => { this.updateTupleDescriptions() }}>Update</Button>
                <Button variant="contained" self={this} style={styles.button} onClick={(e) => { this.onCloseDialog() }}>Cancel</Button>
            </DialogActions>
        </Dialog>
        this.setState({ dialog })
    }

    onCloseDialog() {
        this.setState({ dialog: null })
    }

    confirmUpdateTupleDescriptions() {
        let { dataType } = this.state;
        if (dataType.tupleDescriptions.length > 0) {
            this.showConfirmUpdateDialog()
        } else {
            this.updateTupleDescriptions()
        }
    }

    editTuple(node) {
        let self = this;
        let { appContext } = this.props;
        self.setState({
            dialog: <EditTupleDescriptionDialog
                disableSave={true}
                appContext={appContext}
                tupleDescription={node.tupleDescription}
                tupleIndex={node.tupleIndex}
                dataType={node.dataType}
                onCancel={() => {
                    self.setState({ dialog: null });
                }}
                onDone={(dataType) => {
                    console.log("editTuple done:", dataType);
                    self.setState({ dataType, dialog: null }, self.createTreeData.bind(self));
                }} />
        });
    }

    addTuple() {
        let { dataType } = this.state;

        let newTupleDescription = {
            description: 'New Tuple',
            dataType: 'String',
            classType: 'Answer',
            origin: 'PGHD',
            unit: '',
            valueDescriptions: [],
            index: dataType.tupleDescriptions.length
        }

        dataType.tupleDescriptions.push(newTupleDescription);
        this.setState({ dataType }, this.createTreeData.bind(this));
    }


    deleteTupleDescription(node) {
        let { dataType } = this.state;
        dataType.tupleDescriptions.splice(node.tupleDescription.index, 1);
        for (let i = 0; i < dataType.tupleDescriptions.length; ++i)
            dataType.tupleDescriptions[i].index = i;

        this.setState({ dataType }, this.createTreeData.bind(this));
    }

    updateTupleDescriptions = e => {
        let tupleDescriptions = require('../data/DataTypeTupleDescriptionTemplates.json');
        let { dataType } = this.state;

        let tupleDescriptionItem = tupleDescriptions.tupleDescriptionItems.find((tupleDescriptionItem) => {
            return (tupleDescriptionItem.id === dataType.category)
        })

        if (tupleDescriptionItem) {
            tupleDescriptionItem = JSON.stringify(tupleDescriptionItem)
            tupleDescriptionItem = tupleDescriptionItem.replace(/{{name}}/g, dataType.name)
            tupleDescriptionItem = JSON.parse(tupleDescriptionItem)

            dataType.tupleDescriptions = tupleDescriptionItem.tupleDescriptions
            this.setState({ dataType, dialog: null }, this.createTreeData.bind(this));
        }
    }

    createTreeData() {
        let { dataType } = this.state;
        let tupleDescriptions = dataType.tupleDescriptions;
        let treeData = [];
        for (let j = 0; j < tupleDescriptions.length; j++) {
            let tupleDescription = tupleDescriptions[j];
            if (tupleDescription.oldIndex === undefined)
                tupleDescription.oldIndex = tupleDescription.index;     // save off the original index, so we can detect if tuples have been changed
            let description = tupleDescription.description;
            let nodeId = dataType.dataId + tupleDescription.index;

            let node = {
                isTupleDescription: true,
                dataType,
                nodeId,
                tupleDescription,
                tupleIndex: j,
                text: description
            };

            treeData.push(node);
        }

        console.log("treeData:", treeData);
        this.setState({ treeData });
    }

    getNodeButtons(node) {
        const { readOnly } = this.props;

        let buttons = [];
        buttons.push(<FormLabel style={styles.index_label}>{node.tupleDescription.index}</FormLabel>);
        if (!readOnly) {
            buttons.push(<Tooltip title='Edit'><IconButton onClick={this.editTuple.bind(this, node)}><CreateIcon /></IconButton></Tooltip>);
            buttons.push(<Tooltip title='Delete'><IconButton onClick={this.deleteTupleDescription.bind(this, node)}>
                <DeleteIcon /></IconButton></Tooltip>);
        }

        return buttons;
    }

    getNodeProps({ node }) {
        return {
            listIndex: 0,
            lowerSiblingCounts: [],
            style: styles.tree_node,
            title: node.text,
            buttons: this.getNodeButtons(node)
        };
    }

    onChangeTree(treeData) {
        let { dataType } = this.state;
        let tupleDescriptions = [];
        for (let i = 0; i < treeData.length; ++i) {
            let node = treeData[i];
            tupleDescriptions.push(node.tupleDescription);
            tupleDescriptions[i].index = i;
        }
        dataType.tupleDescriptions = tupleDescriptions;
        this.setState({ dataType, treeData });
    }

    getTupleTree() {
        const { treeData } = this.state;
        let sortableTree = treeData ? <div style={styles.tree} valign='top'>
            <SortableTree
                treeData={treeData}
                maxDepth={3}
                canDrop={() => true}
                onChange={this.onChangeTree.bind(this)}
                theme={FileExplorerTheme}
                canNodeHaveChildren={() => false}
                isVirtualized={true}
                rowdirection='ltr'
                dndType='symptom'
                generateNodeProps={this.getNodeProps.bind(this)} /></div> : null;
        console.log("getTupleTree:", sortableTree);
        return sortableTree;
    }

    render() {
        const { appContext, previewMode } = this.props
        const { dataType, dialog, progress, error } = this.state;

        if (dataType.timeWindow === undefined)
            dataType.timeWindow = 15;
        if (dataType.historyWindow === undefined)
            dataType.historyWindow = 90;
        if (dataType.parentId === undefined)
            dataType.parentId = '';
        if (dataType.referenceUrl === undefined)
            dataType.referenceUrl = '';
        if (dataType.referenceTitle === undefined)
            dataType.referenceTitle = '';
        if (!Array.isArray(dataType.tags))
            dataType.tags = [];

        return (
            <Dialog maxWidth={'lg'} fullWidth={true} model="false" open={true}>
                <DialogTitle>Edit Data Type</DialogTitle>
                <DialogContent>
                    <TextField disabled={true} style={styles.name} label="Data Id" value={dataType.dataId} onChange={this.onChange("dataId")} />
                    <TextField style={styles.name} label="Name" value={dataType.name} onChange={this.onChange("name")} />
                    <Tooltip title="Enter 0 days for unlimited days"><TextField style={styles.number} label="Time Window" value={dataType.timeWindow} type='numeric' onChange={this.onChange("timeWindow")} /></Tooltip>
                    <Tooltip title="Enter 0 days for unlimited days"><TextField style={styles.number} label="History Window" value={dataType.historyWindow} type='numeric' onChange={this.onChange("historyWindow")} /></Tooltip>
                    <br />
                    <TextField style={styles.description} label="Description" value={dataType.description} onChange={this.onChange("description")} />
                    <div style={{ margin: 5 }}>Tags<br />
                    <ChipInput style={styles.description} value={dataType.tags} 
                        onAdd={(chip) => {
                            dataType.tags.push(chip.toUpperCase());
                            this.setState({ dataType });
                        }}
                        onDelete={(chip,index) => {
                            dataType.tags.splice(index,1);
                            this.setState({ dataType });
                        }}
                    />
                    </div>
                    <TextField style={styles.description} label="Reference Title" value={dataType.referenceTitle} onChange={this.onChange("referenceTitle")} />
                    <TextField style={styles.description} label="Reference URL" value={dataType.referenceUrl} onChange={this.onChange("referenceUrl")} />
                    <UploadFile appContext={appContext} folderPath='ref/' onChange={(e) => {
                        dataType.referenceUrl = e; this.setState({ dataType });
                    }} />
                    <br />
                    <SelectDataType label="Parent Data Id" style={styles.select} appContext={this.props.appContext} dataId={dataType.parentId} enableNone={true}
                        onSelect={(select) => {
                            dataType.parentId = select ? select.dataId : '';
                            this.setState({ dataType });
                        }} />
                    <SelectDataType label="Date Data Id" style={styles.select} appContext={this.props.appContext} dataId={dataType.dateId} enableNone={true}
                        onChange={(select) => {
                            dataType.dateId = select ? select.dataId : '';
                            this.setState({ dataType });
                        }} />
                    {dataType.dateId ? <SelectTupleIndex label='Select Date Tuple' style={styles.select} appContext={this.props.appContext} dataId={dataType.dateId} tupleIndex={dataType.dateTupleIndex}
                        onChange={(tupleIndex) => {
                            dataType.dateTupleIndex = tupleIndex;
                            this.setState({ dataType });
                        }} /> : null}
                    <br />
                    <FormControlLabel style={{ marginLeft: 0 }} control={<Checkbox
                        checked={dataType.baseline}
                        onChange={(e) => {
                            dataType.baseline = e.target.checked;
                            this.setState({ dataType });
                        }}
                    />} label="Baseline" />
                    <br />
                    <SelectDataTypeCategory value={dataType.category} onChange={this.onChange("category")} />
                    <FormControl style={styles.select}>
                        <InputLabel>SOAP Category</InputLabel>
                        <Select styles={{ margin: 0 }} value={dataType.soap} onChange={(e) => {
                            let value = e.target.value;
                            if (value === 'none') {
                                dataType.soap = '';
                            } else {
                                dataType.soap = value;
                            }
                            this.setState({ dataType });
                        }}>
                            <MenuItem key={"none"} value={"none"}>none</MenuItem>
                            <MenuItem key={"objective"} value={"objective"}>Objective</MenuItem>
                        </Select>
                    </FormControl>
                    <br />
                    <Button
                        onClick={this.confirmUpdateTupleDescriptions.bind(this)}
                        style={{ marginTop: 16 }} variant="contained">Create Default Tuples</Button>
                    <div align='right'>
                        <Tooltip title='Add Tuple'><IconButton onClick={this.addTuple.bind(this)}><AddIcon /></IconButton></Tooltip>
                    </div>
                    {this.getTupleTree()}
                    {dialog}
                </DialogContent>
                <DialogActions>
                    <table style={{ width: '100%' }}><tbody><tr><td>
                        {!previewMode && <ChangedByButton appContext={appContext} primaryKey={dataType.dataId} collection='DataTypeModel' />}
                    </td><td align='right'>
                            {error}
                            {progress}
                            {!previewMode && <Button disabled={progress !== null} variant='contained' style={styles.button} onClick={this.onSaveIntoPlan.bind(this)}>Save To Plan</Button>}
                            {!previewMode && <Button disabled={progress !== null} variant="contained" style={styles.button} onClick={this.onSave.bind(this, false, null)}>Save</Button>}
                            {!previewMode && <Button disabled={progress !== null} variant="contained" style={styles.button} onClick={this.onDelete.bind(this)}>Delete</Button>}
                            {previewMode && <Button disabled={progress !== null} variant="contained" style={styles.button} onClick={this.onDone.bind(this, false, null)}>Done</Button>}
                            <Button variant="contained" self={this} style={styles.button} onClick={(e) => { this.onCancel() }}>Cancel</Button>
                        </td></tr></tbody></table>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = {
    select: {
        margin: 5,
        width: 300
    },
    tupleBoxHeader: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    number: {
        margin: 5,
        width: 120
    },
    name: {
        margin: 5,
        width: 300
    },
    description: {
        margin: 5,
        width: '75%'
    },
    div: {
        margin: 10
    },
    button: {
        margin: 10
    },
    tree: { height: 1000, width: '100%' },
    tree_node: {
        height: 50,
        width: 500,
        border: 0,
        cursor: 'pointer'
    },
    index_label: { fontSize: 10, display: 'inline-block', color: 'purple', width: 50, textAlign: 'right', marginRight: 30, border: 'none' }
};


export default EditDataTypeDialog;
